import { Amount, Currency } from '../../checkout/CheckoutTypes';
import pushToLocalGtmQueue from '../../../../helpers/gtm/pushToLocalGtmQueue';

function penceToPounds(pence) {
  return (Number(pence) / 100).toFixed(2).toString();
}

type ActionFieldObject = {
  id: string;
  revenue: string;
  coupon?: string;
};

interface EcommerceTrackingPayload {
  currencyCode: 'GBP' | 'USD';
  ecommerce: {
    purchase: {
      actionField: ActionFieldObject;
      products: Array<GaTrackingProduct>;
    };
  };
}

export type TrackingProduct = {
  id?: string;
  quantity?: number;
  category: string;
  name: string;
  price: Amount;
};

export type GaTrackingProduct = {
  id?: string;
  quantity: number;
  category: string;
  name: string;
  price: string;
};

export interface TrackPurchaseObject {
  currencyCode?: Currency;
  transactionId: string;
  totalAmount: Amount;
  coupon?: string;
  products: TrackingProduct[];
  asynchronous?: boolean;
}

export default function trackPurchase({
  currencyCode = 'gbp',
  transactionId,
  totalAmount,
  coupon,
  products,
  asynchronous = false,
}: TrackPurchaseObject) {
  const { dataLayer } = window;
  if (dataLayer && dataLayer.push) {
    const productsArray = products.map(function(baseProduct) {
      return {
        ...baseProduct,
        price: penceToPounds(baseProduct.price),
        quantity: baseProduct.quantity ?? 1,
      };
    });
    const actionField = <ActionFieldObject>{
      id: transactionId,
      revenue: penceToPounds(totalAmount),
    };
    if (coupon) {
      actionField.coupon = coupon;
    }
    const payload = <EcommerceTrackingPayload>{
      currencyCode: currencyCode.toUpperCase(),
      ecommerce: {
        purchase: {
          actionField,
          products: productsArray,
        },
      },
    };
    if (!asynchronous) {
      return dataLayer.push(payload);
    }
    return pushToLocalGtmQueue(payload);
  }
  return false;
}
